import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export enum AccordionTitleModifier {
  WITH_BUTTON = 'with-button',
  MARGIN = 'margin',
  PADDING = 'padding',
  WIDTH_200 = 'width-200',
}

interface AccordionTitleProps {
  category?: string;
  modifier?: Modifier<AccordionTitleModifier>;
}

export function AccordionTitle({ category, modifier, children }: PropsWithChildren<AccordionTitleProps>) {
  return (
    <span className={bem('accordion__category-title', modifier)}>
      <span className="accordion__category-text">{children || category}</span>
    </span>
  );
}
